import { IoCheckmarkCircleOutline } from "react-icons/io5";
import { BiCoinStack } from "react-icons/bi";
import { IoLockClosedOutline } from "react-icons/io5";
import { MdOutlineAutorenew } from "react-icons/md"; // Streamlined Model Lifecycle Management
import { MdOutlineTrendingUp } from "react-icons/md"; // Continuous Model Improvement
import { MdOutlineGavel } from "react-icons/md";
import img1 from "../../../assets/img/Industries/banking&finance/2149311922.jpg";

export default function MainSection7() {
  return (
    <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
      <div className="md:grid flex flex-col-reverse md:grid-cols-2 gap-8 items-center">
        <div className="relative h-[500px] rounded-3xl overflow-hidden">
          <img
            src={img1}
            alt="Workspace with laptop and plant"
            className="object-cover w-full h-full rounded-3xl"
          />
        </div>
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
              RPA and Workflow Automation
            </h1>
            <p className="text-lg text-gray-600">
              Streamline operations and improve efficiency with Robotic Process
              Automation (RPA) and intelligent workflows.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* Feature 1 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <BiCoinStack className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">
                  Loan Processing Automation
                </h3>
              </div>
              <p className="text-gray-600 text-sm">
                Reduce approval times and enhance customer satisfaction with
                automated workflows for loan applications.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <IoCheckmarkCircleOutline className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">
                  Claims Management
                </h3>
              </div>
              <p className="text-gray-600 text-sm">
                Streamline claims processing in insurance with robotic process
                automation (RPA).
              </p>
            </div>

            {/* Feature 3 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <IoLockClosedOutline className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">
                  KYC and AML Compliance
                </h3>
              </div>
              <p className="text-gray-600 text-sm">
                Automate Know Your Customer (KYC) and Anti-Money Laundering
                (AML) checks for faster onboarding and compliance.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
